import {
  GET_AGGREGATE_OVERVIEW,
  GET_AGGREGATE_OVERVIEW_ERROR,
  GET_AGGREGATE_OVERVIEW_EMPTY,
  GET_AGGREGATE_ACCOUNT_TABSCOUNT,
  GET_AGGREGATE_ACCOUNT_TABSCOUNT_ERROR,
  GET_SUSPICIOUS_ACTIVITY,
  GET_SUSPICIOUS_ACTIVITY_ERROR,
  GET_SUSPICIOUS_ACTIVITY_EMPTY,
  GET_CIRCULAR_TRANSACTIONS,
  GET_CIRCULAR_TRANSACTIONS_ERROR,
  GET_CIRCULAR_TRANSACTIONS_EMPTY,
  GET_INTRA_BANK_FUND_TRANSFER,
  GET_INTRA_BANK_FUND_TRANSFER_ERROR,
  GET_INTRA_BANK_FUND_TRANSFER_EMPTY,
  GET_BOUNCED_CHEQUE,
  GET_BOUNCED_CHEQUE_ERROR,
  GET_BOUNCED_CHEQUE_EMPTY,
  GET_CASH_FLOW,
  GET_CASH_FLOW_ERROR,
  GET_CASH_FLOW_EMPTY,
  GET_BIZ_CASHFLOW,
  GET_BIZ_CASHFLOW_ERROR,
  GET_BIZ_CASHFLOW_EMPTY,
  GET_COUNTER_PARTY,
  GET_COUNTER_PARTY_ERROR,
  GET_COUNTER_PARTY_EMPTY,
  GET_ODCC_UTILIZATION,
  GET_ODCC_UTILIZATION_ERROR,
  GET_ODCC_UTILIZATION_EMPTY,
  GET_RECURRING_PAYMENTS,
  GET_RECURRING_PAYMENTS_ERROR,
  GET_RECURRING_PAYMENTS_EMPTY,
  GET_RECURRING_DEPOSITS,
  GET_RECURRING_DEPOSITS_ERROR,
  GET_RECURRING_DEPOSITS_EMPTY,
  GET_EMI_DEPOSITS,
  GET_EMI_DEPOSITS_ERROR,
  GET_EMI_DEPOSITS_EMPTY,
  GET_LOANS,
  GET_LOANS_ERROR,
  GET_LOANS_EMPTY,
  GET_SALARY,
  GET_SALARY_ERROR,
  GET_SALARY_EMPTY,
  GET_CATEGORIES,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_EMPTY,
  LOADER,
  EMPTY_AGGREGATE_ANALYSIS,
  GET_COUNTER_PARTY_MONTHLY,
  GET_COUNTER_PARTY_MONTHLY_ERROR,
  GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION,
  AG_FOR_RE_ANALYSIS,
  AG_TAB_PERSIST,
  GET_DAILY_BALANCE,
  GET_DAILY_BALANCE_ERROR,
  GET_DAILY_BALANCE_EMPTY,
  GET_SUMMARY,
  GET_SUMMARY_ERROR,
  GET_SUMMARY_EMPTY,
  GET_LOAN_ANALYSIS,
  GET_LOAN_ANALYSIS_ERROR,
  GET_LOAN_ANALYSIS_EMPTY,
  GET_AGGREGATE_BUREAU,
  GET_AGGREGATE_BUREAU_ERROR,
  GET_AGGREGATE_BUREAU_EMPTY,
  GET_UPI_TXNS,
  GET_UPI_TXNS_ERROR,
  GET_UPI_TXNS_EMPTY
} from 'src/actions/aggregateAnalysisActions';
import produce from 'immer';

const initialState = {
  agoverview: null,
  agoverviewError: null,
  agTabsCount: null,
  agTabsCountError: null,
  agsuspiciousActivity: null,
  agsuspiciousActivityError: null,
  agcircularTransactions: null,
  agcircularTransactionsError: null,
  agintraBankTransfer: null,
  agintraBankTransferError: null,
  agbouncedCheque: null,
  agbouncedChequeError: null,
  agcashFlow: null,
  agcashFlowError: null,
  agbizCashFlow: null,
  agbizCashFlowError: null,
  agcounterParty: null,
  agcounterPartyError: null,
  agodccUtilization: null,
  agodccUtilizationError: null,
  agrecurringPayments: null,
  agrecurringPaymentsError: null,
  agrecurringDeposits: null,
  agrecurringDepositsError: null,
  agemiDeposits: null,
  agemiDepositsError: null,
  agloans: null,
  agloansError: null,
  agsalary: null,
  agsalaryError: null,
  agcategories: null,
  agcategoriesError: null,
  agisLoading: false,
  agmonthlyCounterparty: null,
  agmonthlyCounterPartyData: null,
  agTabPersist: 'customSummary',
  agDailyBalance: null,
  agDailyBalanceError: null,
  agSummary: null,
  agSummaryError: null,
  agloanAnalysis: null,
  agloanAnalysisError: null,
  agBureau: null,
  agBureauError: null,
  agUpiTxnsAnalysis: null,
  agUpiTxnsAnalysisError: null
};

const aggregateAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.agisLoading = true;
      });
    }

    case GET_AGGREGATE_OVERVIEW: {
      return produce(state, draft => {
        draft.agoverview = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_AGGREGATE_OVERVIEW_ERROR: {
      return produce(state, draft => {
        draft.agoverviewError = action.payload;
        draft.agisLoading = false;
      });
    }

    case GET_AGGREGATE_ACCOUNT_TABSCOUNT: {
      return produce(state, draft => {
        draft.agTabsCount = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_AGGREGATE_ACCOUNT_TABSCOUNT_ERROR: {
      return produce(state, draft => {
        draft.agTabsCountError = action.payload;
        draft.agisLoading = false;
      });
    }

    case GET_AGGREGATE_OVERVIEW_EMPTY: {
      return produce(state, draft => {
        draft.agoverviewError = null;
        draft.agoverview = null;
      });
    }

    case GET_SUSPICIOUS_ACTIVITY: {
      return produce(state, draft => {
        draft.agsuspiciousActivity = action.payload;
        draft.agsuspiciousActivityError = null;
        draft.agisLoading = false;
      });
    }
    case GET_SUSPICIOUS_ACTIVITY_ERROR: {
      return produce(state, draft => {
        draft.agsuspiciousActivityError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_SUSPICIOUS_ACTIVITY_EMPTY: {
      return produce(state, draft => {
        draft.agsuspiciousActivityError = null;
        draft.agsuspiciousActivity = null;
      });
    }

    case GET_CIRCULAR_TRANSACTIONS: {
      return produce(state, draft => {
        draft.agcircularTransactions = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CIRCULAR_TRANSACTIONS_ERROR: {
      return produce(state, draft => {
        draft.agcircularTransactionsError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CIRCULAR_TRANSACTIONS_EMPTY: {
      return produce(state, draft => {
        draft.agcircularTransactionsError = null;
        draft.agcircularTransactions = null;
        draft.agisLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER: {
      return produce(state, draft => {
        draft.agintraBankTransfer = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER_ERROR: {
      return produce(state, draft => {
        draft.agintraBankTransferError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER_EMPTY: {
      return produce(state, draft => {
        draft.agintraBankTransferError = null;
        draft.agintraBankTransfer = null;
        draft.isLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE: {
      return produce(state, draft => {
        draft.agbouncedCheque = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE_ERROR: {
      return produce(state, draft => {
        draft.agbouncedChequeError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE_EMPTY: {
      return produce(state, draft => {
        draft.agbouncedCheque = null;
        draft.agbouncedChequeError = null;
      });
    }

    case GET_CASH_FLOW: {
      return produce(state, draft => {
        draft.agcashFlow = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CASH_FLOW_ERROR: {
      return produce(state, draft => {
        draft.agcashFlowError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CASH_FLOW_EMPTY: {
      return produce(state, draft => {
        draft.agcashFlow = null;
        draft.agcashFlowError = null;
        draft.agisLoading = false;
      });
    }

    case GET_BIZ_CASHFLOW: {
      return produce(state, draft => {
        draft.agbizCashFlow = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_BIZ_CASHFLOW_ERROR: {
      return produce(state, draft => {
        draft.agbizCashFlowError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_BIZ_CASHFLOW_EMPTY: {
      return produce(state, draft => {
        draft.agbizCashFlow = null;
        draft.agbizCashFlowError = null;
        draft.agisLoading = false;
      });
    }

    case GET_COUNTER_PARTY: {
      return produce(state, draft => {
        draft.agcounterParty = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_COUNTER_PARTY_ERROR: {
      return produce(state, draft => {
        draft.agcounterPartyError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_COUNTER_PARTY_EMPTY: {
      return produce(state, draft => {
        draft.agcounterParty = null;
        draft.agcounterPartyError = null;
        draft.agisLoading = false;
      });
    }

    case GET_ODCC_UTILIZATION: {
      return produce(state, draft => {
        draft.agodccUtilization = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_ODCC_UTILIZATION_ERROR: {
      return produce(state, draft => {
        draft.agodccUtilizationError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_ODCC_UTILIZATION_EMPTY: {
      return produce(state, draft => {
        draft.agodccUtilization = null;
        draft.agodccUtilizationError = null;
        draft.agisLoading = false;
      });
    }

    case GET_RECURRING_PAYMENTS: {
      return produce(state, draft => {
        draft.agrecurringPayments = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_RECURRING_PAYMENTS_ERROR: {
      return produce(state, draft => {
        draft.agrecurringPaymentsError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_RECURRING_PAYMENTS_EMPTY: {
      return produce(state, draft => {
        draft.agrecurringPayments = null;
        draft.agrecurringPaymentsError = null;
        draft.agisLoading = false;
      });
    }

    case GET_RECURRING_DEPOSITS: {
      return produce(state, draft => {
        draft.agrecurringDeposits = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_RECURRING_DEPOSITS_ERROR: {
      return produce(state, draft => {
        draft.agrecurringDepositsError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_RECURRING_DEPOSITS_EMPTY: {
      return produce(state, draft => {
        draft.agrecurringDeposits = null;
        draft.agrecurringDepositsError = null;
        draft.agisLoading = false;
      });
    }

    case GET_EMI_DEPOSITS: {
      return produce(state, draft => {
        draft.agemiDeposits = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_EMI_DEPOSITS_ERROR: {
      return produce(state, draft => {
        draft.agemiDepositsError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_EMI_DEPOSITS_EMPTY: {
      return produce(state, draft => {
        draft.agemiDeposits = null;
        draft.agemiDepositsError = null;
        draft.agisLoading = false;
      });
    }

    case GET_LOANS: {
      return produce(state, draft => {
        draft.agloans = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_LOANS_ERROR: {
      return produce(state, draft => {
        draft.agloansError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_LOANS_EMPTY: {
      return produce(state, draft => {
        draft.agloans = null;
        draft.agloansError = null;
        draft.agisLoading = false;
      });
    }

    case GET_SALARY: {
      return produce(state, draft => {
        draft.agsalary = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_SALARY_ERROR: {
      return produce(state, draft => {
        draft.agsalaryError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_SALARY_EMPTY: {
      return produce(state, draft => {
        draft.agsalary = null;
        draft.agsalaryError = null;
        draft.agisLoading = false;
      });
    }

    case GET_CATEGORIES: {
      return produce(state, draft => {
        draft.agcategories = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CATEGORIES_ERROR: {
      return produce(state, draft => {
        draft.agcategoriesError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_CATEGORIES_EMPTY: {
      return produce(state, draft => {
        draft.agcategories = null;
        draft.agcategoriesError = null;
        draft.agisLoading = false;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY: {
      return produce(state, draft => {
        draft.agmonthlyCounterparty = action.payload;
        draft.agForReAnalysis = null;
        // draft.agisLoading = false;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION: {
      return produce(state, draft => {
        draft.agmonthlyCounterPartyData = action.payload;
        draft.agisLoading = false;
        draft.agmonthlyCounterPartyError = null;
      });
    }
    case AG_FOR_RE_ANALYSIS: {
      return produce(state, draft => {
        draft.agForReAnalysis = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY_ERROR: {
      return produce(state, draft => {
        draft.agisLoading = false;
      });
    }

    case GET_DAILY_BALANCE: {
      return produce(state, draft => {
        draft.agDailyBalance = action.payload;
        draft.agisLoading = false;
      });
    }

    case GET_DAILY_BALANCE_ERROR: {
      return produce(state, draft => {
        draft.agDailyBalanceError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_DAILY_BALANCE_EMPTY: {
      return produce(state, draft => {
        draft.agDailyBalanceError = null;
        draft.agDailyBalance = null;
      });
    }

    case GET_SUMMARY: {
      return produce(state, draft => {
        draft.agSummary = action.payload;
        draft.agisLoading = false;
      });
    }

    case GET_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.agSummaryError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.agSummaryError = null;
        draft.agSummary = null;
      });
    }
    case GET_LOAN_ANALYSIS: {
      return produce(state, draft => {
        draft.agloanAnalysis = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_LOAN_ANALYSIS_ERROR: {
      return produce(state, draft => {
        draft.agloanAnalysisError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_LOAN_ANALYSIS_EMPTY: {
      return produce(state, draft => {
        draft.agloanAnalysis = null;
        draft.agloanAnalysisError = null;
        draft.agisLoading = false;
      });
    }

    case GET_AGGREGATE_BUREAU: {
      return produce(state, draft => {
        draft.agBureau = action.payload;
        draft.agisLoading = false;
      });
    }

    case GET_AGGREGATE_BUREAU_ERROR: {
      return produce(state, draft => {
        draft.agBureauError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_AGGREGATE_BUREAU_EMPTY: {
      return produce(state, draft => {
        draft.agBureauError = null;
        draft.agBureau = null;
      });
    }

    case GET_UPI_TXNS: {
      return produce(state, draft => {
        draft.agUpiTxnsAnalysis = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_UPI_TXNS_ERROR: {
      return produce(state, draft => {
        draft.agUpiTxnsAnalysisError = action.payload;
        draft.agisLoading = false;
      });
    }
    case GET_UPI_TXNS_EMPTY: {
      return produce(state, draft => {
        draft.agUpiTxnsAnalysis = null;
        draft.agUpiTxnsAnalysisError = null;
        draft.agisLoading = false;
      });
    }

    case EMPTY_AGGREGATE_ANALYSIS: {
      return produce(state, draft => {
        draft.agoverview = null;
        draft.agoverviewError = null;
        draft.agTabsCount = null;
        draft.agTabsCountError = null;
        draft.agsuspiciousActivity = null;
        draft.agsuspiciousActivityError = null;
        draft.agcircularTransactions = null;
        draft.agcircularTransactionsError = null;
        draft.agintraBankTransfer = null;
        draft.agintraBankTransferError = null;
        draft.agbouncedCheque = null;
        draft.agbouncedChequeError = null;
        draft.agcashFlow = null;
        draft.agcashFlowError = null;
        draft.agUpiTxnsAnalysis = null;
        draft.agUpiTxnsAnalysisError = null;
        draft.agbizCashFlow = null;
        draft.agbizCashFlowError = null;
        draft.agcounterParty = null;
        draft.agcounterPartyError = null;
        draft.agodccUtilization = null;
        draft.agodccUtilizationError = null;
        draft.agrecurringPayments = null;
        draft.agrecurringPaymentsError = null;
        draft.agrecurringDeposits = null;
        draft.agrecurringDepositsError = null;
        draft.agemiDeposits = null;
        draft.agemiDepositsError = null;
        draft.agloans = null;
        draft.agloansError = null;
        draft.agsalary = null;
        draft.agsalaryError = null;
        draft.agcategories = null;
        draft.agcategoriesError = null;
        draft.agisLoading = false;
        draft.agmonthlyCounterparty = null;
        draft.agmonthlyCounterPartyData = null;
        draft.agDailyBalance = null;
        draft.agDailyBalanceError = null;
        draft.agSummary = null;
        draft.agSummaryError = null;
        draft.agBureau = null;
        draft.agBureauError = null;
        draft.agloanAnalysis = null;
        draft.agloanAnalysisError = null;
      });
    }

    case AG_TAB_PERSIST: {
      return produce(state, draft => {
        draft.agTabPersist = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default aggregateAnalysisReducer;
